import React, { useEffect, useRef, forwardRef, useImperativeHandle } from 'react'
import { Spin } from 'antd'
import Empty from 'meinian-package/src/baseComponent/empty'
import classnames from 'classnames'
import Chart from 'component/chart/base'
import request from 'meinian-package/src/utils/request'
import useAsyncLoading from 'common/hooks/useAsyncLoading'
import styles from './index.module.less'

const getChartConfig = (dataSource) => {
  const date = dataSource.map(item => item.date)
  const count = dataSource.map(item => item.count)

  const option = {
    color: '#6B87FE',
    tooltip: {
      trigger: 'axis',
      formatter: (a) => {
        let tip = ''
        a.forEach((m) => {
          tip += `${m.marker}${m.name}<br>&nbsp;&nbsp;&nbsp;${m.data}款`
        })
        return tip || 'Loading'
      }
    },
    xAxis: {
      type: 'category',
      textStyle: { color: '#87878A', },
      axisLabel: {
        color: '#87878A',
        margin: 21
      },
      axisTick: {
        show: false,
      },
      data: date
    },
    yAxis: {
      type: 'value',
      nameTextStyle: {
        color: '#87878A',
      },
      axisLabel: {
        color: '#87878A',
        formatter(value) {
          return `${value}`
        }
      },
      splitLine: {
        lineStyle: {
          color: '#E8E8E9'
        }
      }
    },
    grid: {
      top: 40,
      left: 40,
      right: 24,
    },
    series: [
      {
        data: count,
        type: 'line',
        symbol: 'circle',
        symbolSize: 8,
        itemStyle: {
          color: '#6B87FE', // 颜色
        }
      }
    ]
  }
  return option
}

export default forwardRef(({ className, style, baseParams }, ref) => {
  const $chart = useRef()
  const newCollectData = useAsyncLoading({ fetchData: (_params) => fetchData(_params), params: baseParams })

  useImperativeHandle(ref, () => ({
    ...newCollectData
  }))

  useEffect(() => {
    if (!$chart.current) {
      return
    }
    const myChart = $chart.current.getEchartsInstance()
    const onResize = () => {
      myChart.resize()
    }
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [$chart.current])

  const fetchData = async (_baseParams) => {
    const result = await request.sget('/zhikuan/mn/collect-statistic/v2/collect-trend', _baseParams, 'collect_statistic_collect_trend')
    return result
  }

  return (<div className={classnames(styles['meinian-line-chart'], { className })} style={style}>
    <div className="meinian-line-chart-title">采集新增分日统计</div>
    <Spin spinning={newCollectData.loading}>
      {
      newCollectData.data?.collectTrends?.length ? <Chart ref={$chart} type={null} customConfig={getChartConfig(newCollectData.data?.collectTrends)} className="meinian-line-chart-content" /> : <Empty type="analysis" noPadding />
    }
    </Spin>
  </div>)
})
